// extracted by mini-css-extract-plugin
export default {"section-heading":"CurrentInfra_section-heading__h7v4K","current-infra-card":"CurrentInfra_current-infra-card__sjQMC","image-title-holder":"CurrentInfra_image-title-holder__ssuCY"};